// File: src/components/car/TopFeatures.jsx
import React, { useState } from 'react';
import './TopFeatures.css';
import TopFeaturesModal from './TopFeaturesModal';

/**
 * Normalize features from backend array format to grouped object
 */
const normalizeFeatures = (rawFeatures) => {
  if (!rawFeatures) return {};
  
  if (Array.isArray(rawFeatures)) {
    const grouped = {};
    
    rawFeatures.forEach((feature) => {
      const category = (feature.category || 'OTHER').toUpperCase();
      if (!grouped[category]) {
        grouped[category] = [];
      }
      grouped[category].push({
        name: feature.name,
        available: feature.available !== false
      });
    });
    
    return grouped;
  }
  
  if (typeof rawFeatures === 'object') {
    return rawFeatures;
  }
  
  return {};
};

const TopFeatures = ({ car, onBookNow, onTestDrive }) => {
  const [showModal, setShowModal] = useState(false);
  
  console.log('🔍 TopFeatures received car:', car);
  console.log('📋 car_features data:', car?.car_features);
  
  const features = normalizeFeatures(car?.car_features);
  console.log('✅ Normalized features:', features);
  
  // Get first 3-4 features from each category for preview
  const getPreviewFeatures = () => {
    const preview = {};
    const categories = ['COMFORT & CONVENIENCE', 'SAFETY', 'ENTERTAINMENT & COMMUNICATION'];
    
    categories.forEach(cat => {
      if (features[cat] && features[cat].length > 0) {
        preview[cat] = features[cat].slice(0, 3);
      }
    });
    
    return preview;
  };
  
  const previewFeatures = getPreviewFeatures();
  
  if (Object.keys(features).length === 0) {
    return (
      <div className="top-features-section">
        <h3 className="section-title">Top Features of this car</h3>
        <p className="no-features">Feature information not available</p>
      </div>
    );
  }

  return (
    <>
      <div className="top-features-section">
        <h3 className="section-title">Top Features of this car</h3>
        
        <div className="features-categories">
          {Object.entries(previewFeatures).map(([category, items]) => (
            <div key={category} className="feature-category">
              <h4 className="category-title">{category}</h4>
              <ul className="feature-list">
                {items.map((feature, index) => (
                  <li key={index} className="feature-item">
                    <span className={`feature-check ${feature.available ? 'available' : 'unavailable'}`}>
                      {feature.available ? '✓' : '○'}
                    </span>
                    <span className="feature-name">{feature.name}</span>
                    {feature.available && (
                      <span className="info-icon">ℹ️</span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <button 
          className="view-all-features-btn"
          onClick={() => setShowModal(true)}
        >
          VIEW ALL FEATURES
        </button>
      </div>

      <TopFeaturesModal 
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        features={features}
        car={car}
        onBookNow={onBookNow}
        onTestDrive={onTestDrive}
      />
    </>
  );
};

export default TopFeatures;